import ContractMdl from '@/models/HumanResource/HrContract'
import contractIncludes from '../contract/contractIncludes'
export default async contractId => {
    //
    try {
        //
        let response = await ContractMdl.include([...contractIncludes,'hr_contract_asset_discount']).find(
            contractId
        )
        return response
    } catch (error) {
        //
        return error.response.data
    }
}
